var map = {
	"./anyfile.png": 5411,
	"./archive.png": 2266,
	"./csv.png": 4208,
	"./doc.png": 2542,
	"./jpg.png": 5271,
	"./pdf.png": 2033,
	"./png.png": 5863,
	"./video.png": 5769,
	"./xls.png": 9709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7243;